import ContentsContainer from './ContentsContainer';

export default ContentsContainer;
